import React, { ReactElement } from 'react';
import { createKey } from 'b2b-apps/shop/common/utils/key/key';
import { ComponentType, Props } from './BulletPoints.types';

const BulletPoints: ComponentType = ({ bulletPoints }: Props): ReactElement => (
  <div className="ProductData-BulletPoints">
    <ul className="cds-List cds-List--Piped">
      {Array.isArray(bulletPoints)
        && bulletPoints.map((item, index) => (
          <li key={createKey(item, index)}>{item}</li>
        ))}
    </ul>
  </div>
);

export { BulletPoints };
